/**
 * Chantier : - (feedback in-app, hors chantier structure)
 * Regle metier : - (outil interne, hors domaine)
 * Decision : spec PLAN/specifications-feedback-inapp.md (barreau 1)
 * Envoi best-effort d'un ticket de feedback vers le relai Make (webhook), qui cree
 * la page Notion. Auth ralentisseur via header x-make-apikey. Non bloquant cote UI.
 */

export type FeedbackType = 'bug' | 'evolution';

/** Erreur de configuration (VITE_FEEDBACK_* absents) — distincte d'un echec reseau/HTTP. */
export class FeedbackConfigError extends Error {}

export interface FeedbackInput {
  type: FeedbackType;
  typeUtilisateur: string;
  pageUrl: string;
  description: string;
  route: string;
  reporterNom: string;
  reporterEmail: string;
  // Champs specifiques bug (chaines vides si type !== 'bug').
  objetType: string;
  objetRef: string;
  dateIncident: string;
  messageErreur: string;
}

export async function submitFeedback(input: FeedbackInput): Promise<void> {
  const url = import.meta.env.VITE_FEEDBACK_WEBHOOK_URL;
  const apiKey = import.meta.env.VITE_FEEDBACK_KEY;
  if (!url || !apiKey) {
    throw new FeedbackConfigError('Feedback non configure (VITE_FEEDBACK_*)');
  }

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-make-apikey': apiKey,
    },
    body: JSON.stringify({
      app: 'serme',
      type: input.type,
      type_utilisateur: input.typeUtilisateur,
      page_url: input.pageUrl,
      description: input.description,
      route: input.route,
      version: __APP_VERSION__,
      reporter_nom: input.reporterNom,
      reporter_email: input.reporterEmail,
      objet_type: input.objetType,
      objet_ref: input.objetRef,
      date_incident: input.dateIncident,
      message_erreur: input.messageErreur,
    }),
    // Borne le temps d'attente : sans ca, un Make qui ne repond pas laisse le bouton fige.
    signal: AbortSignal.timeout(15000),
  });

  if (!response.ok) {
    throw new Error(`Relai feedback: HTTP ${response.status}`);
  }
}
